import { BaseFiltroPaginate } from "resources/enums/paginate";
import { PaginateQuery } from "resources/types/shared";
import { useCallback, useState } from "react";
import { StatusManutencaoEnum } from "core/features/manutencao/typings";
import moment from "moment";

export interface FiltroManutencao extends PaginateQuery {
  statusId: StatusManutencaoEnum | undefined;
  dataInicio: string;
  dataFim: string;
  emAtraso?: "true";
  tenantsIds?: string[];
}

export const filtroDefaultManutencao = {
  search: "",
  page: 1,
  limit: BaseFiltroPaginate.Limit,
  statusId: undefined,
  tenantsIds: undefined,
  dataInicio: moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD"),
  dataFim: moment().endOf("month").format("YYYY-MM-DD"),
};

function useFiltroManutencao() {
  const [filtro, setFiltro] = useState<FiltroManutencao>({
    ...filtroDefaultManutencao,
    dataInicio: moment()
      .subtract(1, "month")
      .startOf("month")
      .format("YYYY-MM-DD"),
    dataFim: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroManutencao>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const onResetFiltro = useCallback(() => {
    setFiltro(filtroDefaultManutencao);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroManutencao;
